var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-time-picker',_vm._b({attrs:{"value":_vm.currentTime,"disabled-hours":_vm.customDisabledHours,"disabled-minutes":_vm.customDisabledMinutes,"disabled-seconds":_vm.customDisabledSeconds},on:{"change":_vm.handleChange}},'a-time-picker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }